export default {
  getType(state) {
    return state.type
  },
  getPartner(state) {
    return state.partner
  },
  getCredentials(state) {
    return {
      email: state.email,
      password: state.password,
      confirmPassword: state.confirmPassword
    }
  },
  getProfile(state) {
    return {
      firstName: state.firstName,
      lastName: state.lastName,
      phone: state.phone,
      birthdate: state.birthdate,
      gender: state.gender
    }
  },
  getAddress(state) {
    return {
      line1: state.line1,
      line2: state.line2,
      city: state.city,
      state: state.state,
      zip: state.zip
    }
  },
  getFormData(state) {
    return {
      email: state.email,
      password: state.password,
      confirmPassword: state.confirmPassword,

      firstName: state.firstName,
      lastName: state.lastName,
      phone: state.phone,
      birthdate: state.birthdate,
      gender: state.gender,
      ssn: state.ssn,

      line1: state.line1,
      line2: state.line2,
      city: state.city,
      state: state.state,
      zip: state.zip
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/registration/getters.js